import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18edae9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "l-page ha-page"
}
const _hoisted_2 = { class: "ha-identification l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "本人確認", -1))
const _hoisted_4 = { class: "ha__sec ha-identification__sec" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__lead" }, "ご本人確認の為再度ログインをお願いします。", -1))
const _hoisted_6 = { class: "ha-identification__field-container" }
const _hoisted_7 = {
  key: 0,
  class: "p-errors"
}
const _hoisted_8 = { class: "c-error" }
const _hoisted_9 = { class: "p-fields" }
const _hoisted_10 = { class: "c-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "集英社ID（メールアドレス）", -1))
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "c-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "password"
}, "パスワード", -1))
const _hoisted_17 = { class: "c-field__body" }
const _hoisted_18 = { class: "c-field__input" }
const _hoisted_19 = ["type", "maxlength"]
const _hoisted_20 = { class: "c-field has-mt" }
const _hoisted_21 = { class: "c-field__auto-signin" }
const _hoisted_22 = {
  class: "c-field__checkbox",
  for: "auto-signin-off"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自動ログインを無効にする", -1))
const _hoisted_24 = { class: "c-field has-submit has-mt" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "ha-identification__list" }
const _hoisted_29 = { class: "ha-identification__listitem" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワードを忘れた方", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワードを忘れた方", -1))
const _hoisted_32 = { class: "ha-identification__listitem" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" ご本人でない場合はこちら ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isDisp)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("section", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.asyncDeterringWrap(_ctx.login, this)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.errorMsgRef)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errorMsgRef), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("fieldset", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "username",
                          name: "username",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailRef) = $event)),
                          placeholder: "******@**.**.jp",
                          autocomplete: "email",
                          required: "",
                          disabled: (!_ctx.linkageInfo.emailParamNotRequired)
                        }, null, 8, _hoisted_14), [
                          [_vModelText, _ctx.emailRef]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.passwordToggle.fieldType,
                          id: "password",
                          name: "password",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordRef) = $event)),
                          maxlength: _ctx.PASSWORD_MAX_LENGTH,
                          placeholder: "英字大小文字、数字を含む8文字以上",
                          autocomplete: "current-password",
                          required: ""
                        }, null, 8, _hoisted_19), [
                          [_vModelDynamic, _ctx.passwordRef]
                        ]),
                        _createElementVNode("i", {
                          class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordToggle.isOn }]),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordToggle)))
                        }, null, 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "auto-signin-off",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.disableAutoLoginRef) = $event)),
                          id: "auto-signin-off"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.disableAutoLoginRef]
                        ]),
                        _hoisted_23
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "ha-btn is-submit",
                      disabled: !(_ctx.passwordRef) || _ctx.isDeterringRef
                    }, _hoisted_27, 8, _hoisted_25)
                  ]),
                  _createElementVNode("ul", _hoisted_28, [
                    _createElementVNode("li", _hoisted_29, [
                      (_ctx.$route.name === _ctx.routeNames.SIGNUP_IDENTIFICATION)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: _ctx.routeNames.SIGNUP_RESET_PASSWORD, query: { reset_email: _ctx.linkageInfo.email, retUrl: _ctx.returnUrlRef } },
                            class: "c-link"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { name: _ctx.routeNames.RESET_PASSWORD, query: { reset_email: _ctx.linkageInfo.email, retUrl: _ctx.returnUrlRef } },
                            class: "c-link"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          }, 8, ["to"]))
                    ]),
                    _createElementVNode("li", _hoisted_32, [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.routeNames.LOGIN },
                        class: "c-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}